<template>
  <nuttrema-layout-form-standard :edit="edit" :theme="theme" :saveError="StuffToEatDetails.saveError">
    <template slot="center">

      <el-form
         label-width="20em"
        :rules="rules"
        :ref="formRef"
        :model="formData"
        :label-position="labelPosition">

        <section>
          <h4 class="section-title">{{ $t('label.basic') }}</h4>
          <div class="section-items">
            <el-form-item :label="$t('label.name')" prop="name">
              <el-col :span="16">
                <el-input v-model="formData.name" :disabled="!edit"></el-input>
              </el-col>
            </el-form-item>

            <el-form-item :label="$t('label.description')" prop="description">
              <el-col :span="24">
                <el-input
                   type="textarea"
                   v-model="formData.description"
                  :autosize="{ minRows: 2, maxRows: 15 }"
                  :disabled="!edit">
                </el-input>
              </el-col>
            </el-form-item>

            <el-form-item :label="$t('label.ingredients')" prop="ingredients">
              <el-col :span="24">
                <nuttrema-medium-editor v-model="formData.ingredients" :edit="edit" :disabled="!edit" hint-label="label.you_can_use_html_labels"></nuttrema-medium-editor>
              </el-col>
            </el-form-item>

            <!-- <el-form-item :label="$t('label.instructions')" prop="instructions">
              <el-col :span="24">
                <el-input
                   type="textarea"
                   v-model="formData.instructions"
                  :autosize="{ minRows: 2, maxRows: 15 }"
                  :disabled="!edit">
                </el-input>
              </el-col>
            </el-form-item> -->

          </div>
        </section>

        <section>
          <h4 class="section-title">{{ $t('label.categorisation') }}</h4>
          <div class="section-items">
            <el-form-item :label="$t('label.general_food_category')">
              <el-col class="el-col--min-25em" :span="8">
                <el-cascader
                   v-model="formData.entity_type_category_id"
                   class="w-100"
                  :disabled="!edit"
                  :clearable="edit"
                  :filterable="true"
                  :options="_get(StuffToEatTypeCategories, 'data', [])"
                  :props="{ label: 'name', value: 'id', children: 'SubCategories' }"
                  :show-all-levels="false"
                  :debounce="500">
                </el-cascader>
              </el-col>
            </el-form-item>
          </div>
        </section>
      </el-form>
    </template>

    <template slot="footer">

      <div class="footer-row" v-if="id !== -1">
        <el-button type="primary" size="small" :loading="isSaving" :disabled="!isDataChanged" @click="submitForm">
          {{ $t('label.save_changes') }}
        </el-button>

        <el-button type="text" size="small" @click="cancelChanges">
          <span v-if="showDoneButton">{{ $t('label.done') }}</span>
          <span v-else>{{ $t('label.cancel') }}</span>
        </el-button>
      </div>

      <div class="footer-row" v-else>
        <el-button type="primary" size="small" :loading="isSaving" :disabled="!isDataChanged" @click="submitForm">
          {{ $t('label.create') }}
        </el-button>

        <el-button type="text" size="small" @click="cancelChanges">
          <span v-if="showDoneButton">{{ $t('label.done') }}</span>
          <span v-else>{{ $t('label.cancel') }}</span>
        </el-button>
      </div>
    </template>

  </nuttrema-layout-form-standard>
</template>

<script>
import { pick, last } from 'lodash';

import NuttremaLayoutFormStandard from 'components/ui/layout/nuttrema-layout-form-standard';
import FormStandardBehavior from 'src/components/mixins/form-standard-behavior';

import StuffToEatInfoSmallCard from 'components/ui/card/stuff-to-eat-info-small-card';
import NuttremaGroupAndSort from 'components/ui/panels/nuttrema-panel-group-and-sort';
import NuttremaMediumEditor from 'components/ui/editor/nuttrema-medium-editor';

export default {
  name: 'form-stuff-to-eat-main-details',
  mixins: [FormStandardBehavior],
  props: {
    id: {
      required: false,
      default: null,
    },
    labelPosition: {
      type: String,
      required: false,
      default: 'right',
    },
    StuffToEatDetails: {
      type: Object,
      required: false,
    },
    StuffToEatTypeCategories: {
      required: false,
      default: null,
    },
    edit: {
      type: Boolean,
      required: false,
      default: false,
    },
    theme: {
      type: String,
      required: false,
      default: null,
    },
  },
  components: {
    NuttremaMediumEditor,
    NuttremaGroupAndSort,
    StuffToEatInfoSmallCard,
    NuttremaLayoutFormStandard,
  },
  data() {
    return {
      formData: {
        name: null,
        description: null,
        instructions: null,
        ingredients: null,
        entity_type_category_id: null,
      },
      rules: {
        name: [
          {
            required: true,
            trigger: 'blur',
            message: this.formatValidationMessage(
              'validation.required',
              'label.name',
              true
            ),
          },
        ],
      },
    };
  },
  methods: {
    setFormData() {
      if (this.StuffToEatDetails) {
        this.formData = pick(this.StuffToEatDetails.data, [
          'name',
          'description',
          // 'instructions',
          'ingredients',
          'entity_type_category_id',
        ]);
      }
    },
    getFormData() {
      const data = {};
      data.name = this.formData.name;
      data.description = this.formData.description || '';
      data.ingredients = this.formData.ingredients || '';
      data.entity_type_category_id = last(this.formData.entity_type_category_id) || '';
      return data;
    },
    applyTextEdit() {},
  },
  created() {
    this.stateData = this.StuffToEatDetails;
    this.formRef = 'form-stuff-to-eat-main-details';
    this.setFormData();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/professional/stuff-to-eat/shared/details/main-details/form-stuff-to-eat-main-details-cred.vue